module.exports = __webpack_public_path__ + "static/img/index2(1)_08.df82c55.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/images/index2(1)_08.png
// module id = 3122
// module chunks = 1